export function mapRange(value, min0, max0, min1, max1) {
  return min1 + ((value - min0) / (max0 - min0)) * (max1 - min1);
}

export function clamp(value, min, max) {
  return Math.max(min, Math.min(value, max));
}